import { Component, OnInit, Input, OnDestroy, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ParametersService } from '../../../services/parameters.service';
import { BaseControlValueAccessor } from '../../../core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'jhi-civilite',
  templateUrl: './civilite.component.html',
  styleUrls: ['./civilite.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: CiviliteComponent,
        multi: true
    }
]
})
export class CiviliteComponent extends BaseControlValueAccessor implements OnInit, OnDestroy, OnChanges {

  @Input()
  disabled: boolean;

  @Input()
  isForMoraleIdentity: boolean;

  civilities: Array<string> = [];

  value: string;

  private _AllCivilities: Array<string> = [];
  private subscription: Subscription;

  constructor(injector: Injector, private parametersService: ParametersService) {
    super(injector)
   }

  ngOnInit(): void {
    this.subscription = this.parametersService
      .getParameters()
      .subscribe(parameters =>  {
        this._AllCivilities = parameters.civilities;
        this.updateDispalyedCivilities(this.isForMoraleIdentity);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isForMoraleIdentity) {
      this.updateDispalyedCivilities(changes.isForMoraleIdentity.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    super.ngOnDestroy();
  }

  protected modelValueChanged(value: string): void {
    this.value = value;
  }

  private updateDispalyedCivilities(isForMoraleIdentity: boolean) {
    this.civilities = this._AllCivilities.filter(civility => isForMoraleIdentity || ['Monsieur', 'Madame'].some(c => c === civility));
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/identite-personne/civilite/civilite.component.ts